module.exports = __webpack_public_path__ + "static/img/chain-contract-num.14af0c5e.png";